<template>
  <section class="su-platform">
    <div class="su-title">
      <p>платформа</p>
      <h2>
        <span>единое пространство для&nbsp;обучения</span>,
        поиска единомышленников и&nbsp;общения с&nbsp;друзьями
      </h2>
    </div>

    <div class="su-platform__items">
      <div class="su-platform__block su-platform__block-1">
        <div class="su-platform__block_cheap">
          <span>классный руководитель</span>
          <span>куратор</span>
          <span>наставник</span>
          <span>психолог</span>
          <span>преподаватель</span>
        </div>
        <h6 class="su-platform__block_title">
          постоянная поддержка
        </h6>
        <p class="su-platform__block_text">
          кураторы, наставники и&nbsp;преподаватели поддерживают ученика в&nbsp;телеграм чатах,
          помогают решить задания на&nbsp;платформе и&nbsp;объясняют теорию вне&nbsp;уроков
        </p>
      </div>

      <div class="su-platform__block su-platform__block-2">
        <h6 class="su-platform__block_title">
          более 10 000 уроков
        </h6>
        <p class="su-platform__block_text">
          каждому ученику доступны безграничные возможности для&nbsp;обучения
          профильным навыкам и&nbsp;школьным предметам
        </p>
      </div>

      <div class="su-platform__block su-platform__block-3">
        <h6 class="su-platform__block_title">
          аналитика успеваемости
        </h6>
        <p class="su-platform__block_text">
          простой и&nbsp;удобный инструмент для&nbsp;детального анализа успеваемости ребенка
        </p>
      </div>

      <div class="su-platform__block su-platform__block-4">
        <h6 class="su-platform__block_title">
          удобный календарь мероприятий
        </h6>
        <p class="su-platform__block_text">
          все&nbsp;активности собраны в&nbsp;одном месте, чтобы&nbsp;точно ничего не&nbsp;пропустить
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SuPlatform',
};
</script>

<style scoped lang="scss">

.su-platform {
  .su-title {
    margin-bottom: 2.5rem;

    @include media-down($size-tablet) {
      p {
        top: 0.6rem;
      }

      h2 {
        font-size: 2.8rem;
      }
    }

    @include media-down($size-mobile) {
      p {
        top: 0;
      }

      h2 {
        font-size: 2.8rem;
      }
    }
  }

  .su-platform__items {
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 1.25rem / 2));
    gap: 1.25rem;

    @include media-down($size-tablet) {
      grid-template-columns: repeat(2, calc(50% - 0.4rem));
      grid-template-rows: calc(var(--scale) * 512) calc(var(--scale) * 512);
      gap: 0.8rem;
    }

    @include media-down($size-mobile) {
      grid-template-columns: 100%;
      grid-template-rows: repeat(4, 51.2rem);
    }
  }

  .su-platform__block {
    padding: 2.5rem;
    position: relative;
    background-color: #FFFFFF;
    background-repeat: no-repeat;
    border-radius: 2.5rem;

    @include media-down($size-tablet) {
      padding: 1.6rem 1.4rem 1.6rem 1.6rem;
    }

    &_cheap {
      margin-bottom: 1.25rem;
      display: flex;
      gap: 0.25rem;

      @include media-down($size-tablet) {
        margin-bottom: 2rem;
        flex-wrap: wrap;
      }

      span {
        padding: calc(var(--scale) * 10) 1.25rem;

        background-color: rgba(#FFFFFF, 0.01);
        border: 1px solid #CACACB;
        backdrop-filter: blur(5px);
        border-radius: 2.5rem;

        font-style: normal;
        font-weight: 500;
        font-size: 1rem;
        line-height: 130%;
        color: #02120F;

        @include media-down($size-tablet) {
          padding: 0.6rem 1.1rem;
          font-size: 1.4rem;
        }
      }
    }

    &_title {
      margin-bottom: 0.75rem;

      font-style: normal;
      font-weight: 500;
      font-size: 3rem;
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        margin-bottom: 0.8rem;
        font-size: 4rem;
        letter-spacing: -0.04em;
      }
    }

    &_text {
      font-style: normal;
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
        line-height: 110%;
      }
    }

    &-1 {
      background-image: url("/v2/school-university/platform/img-1.webp");
      background-position: bottom;
      background-size: 100% auto;

      .su-platform__block_text {
        max-width: calc(var(--scale) * 560);
      }

      @include media-down($size-tablet) {
        background-image: url("/v2/school-university/platform/img-1-mob.webp");
      }
    }

    &-2 {
      background-image: url("/v2/school-university/platform/img-2.webp");
      background-position: bottom;
      background-size: 100% auto;

      @include media-down($size-tablet) {
        background-image: url("/v2/school-university/platform/img-2-mob.webp");
      }
    }

    &-3 {
      margin-top: calc(-1 * var(--scale) * 227);

      background-image: url("/v2/school-university/platform/img-3.webp");
      background-position: bottom 2.5rem right 2.5rem;
      background-size: calc(var(--scale) * 715) auto;

      @include media-down($size-tablet) {
        margin-top: 0;
        background-image: url("/v2/school-university/platform/img-3-mob.webp");
        background-size: calc(var(--scale) * 333) auto;
        background-position: right 0.8rem bottom 0.8rem;
      }
    }

    &-4 {
      background-image: url("/v2/school-university/platform/img-4.webp");
      background-position: bottom 2.5rem right;
      background-size: auto calc(var(--scale) * 327);

      .su-platform__block_text {
        max-width: calc(var(--scale) * 360);
      }

      @include media-down($size-tablet) {
        background-image: url("/v2/school-university/platform/img-4-mob.webp");
        background-size: calc(100% - 0.8rem) auto;
        background-position: center bottom 0.8rem;
      }
    }

    &-1,
    &-4 {
      height: calc(var(--scale) * 493);

      @include media-down($size-tablet) {
        height: 100%;
      }

      .su-platform__block_title {
        max-width: calc(var(--scale) * 560);
      }
    }

    &-2,
    &-3 {
      height: calc(var(--scale) * 720);

      @include media-down($size-tablet) {
        height: 100%;
      }

      .su-platform__block_title,
      .su-platform__block_text {
        max-width: calc(var(--scale) * 615);
      }
    }
  }
}

</style>
